import { useIsMultiDraft } from './useIsMultiDraft';
import { useTemplateEngine } from './useTemplateEngine';

export const useProjectSettings = () => {
  const { isTemplateEngineEnabled } = useTemplateEngine();
  const isMultiDraftEnabled = useIsMultiDraft();

  return {
    isMultiDraftEnabled,
    isTemplateEngineEnabled,
  };
};
